export default "__VITE_ASSET__DEt8iXn7__"